import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress MetaMask connection errors if MetaMask extension is installed but not needed
// This happens when MetaMask extension tries to auto-connect but the app doesn't use it
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    if (reason) {
      const reasonString = String(reason);
      const reasonMessage = reason?.message || reasonString;
      
      // Suppress MetaMask connection errors
      if (
        reasonString.includes('MetaMask') ||
        reasonMessage.includes('MetaMask') ||
        reasonString.includes('Failed to connect') ||
        (reasonString.includes('addListener') && reasonString.includes('undefined'))
      ) {
        event.preventDefault();
        // Optionally log a warning in development
        if (process.env.NODE_ENV === 'development') {
          console.warn('MetaMask connection error suppressed (app does not use MetaMask)');
        }
      }
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
